<template>
  <nav v-if="totalPages>1" class="mt-4">
    <ul class="pagination justify-content-center">
      <li :class="{'page-item': true, disabled: currentPage<2}">
        <span @click="emitPageChangedEvent(1)" class="page-link btn btn-sm btn-secondary">First</span>
      </li>
      <li :class="{'page-item': true, disabled: currentPage<2}">
        <span @click="emitPageChangedEvent(currentPage-1)" class="page-link btn btn-sm btn-secondary">Previous</span>
      </li>

      <li class="page-item disabled ml-1 mr-1">
        <span style="font-size:1.2em;">&nbsp;-&nbsp;Page: {{ currentPage }}/{{ totalPages }}, Total Rows: {{ totalRows }}&nbsp;-&nbsp;</span>
      </li>

      <li :class="{'page-item': true, disabled: currentPage>=totalPages}">
        <span @click="emitPageChangedEvent(currentPage+1)" class="page-link btn btn-sm btn-secondary">Next</span>
      </li>
      <li :class="{'page-item': true, disabled: currentPage>=totalPages}">
        <button type="button" @click="emitPageChangedEvent(totalPages)" class="page-link btn btn-sm btn-secondary">Last</button>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: "pagination",
  props: {
    currentPage: Number,
    perPage: Number,
    totalRows: Number,
    totalPages: Number,
  },
  methods: {
    emitPageChangedEvent(page) {
      this.$emit('pageChanged', page);
    }
  }
};
</script>
<style>
.page-item > .page-link {
  cursor: pointer;
}
</style>
